import experiment from 'experiment';
import type { EditorAPI } from '#packages/editorAPI';

export function getIsMobileBlockReparentingEnabled(editorAPI: EditorAPI) {
  return (
    editorAPI.isMobileEditor() &&
    (experiment.getValue('se_blockReparentingOnMobile') === 'B' ||
      experiment.getValue('se_blockReparentingOnMobile') === 'C')
  );
}
